
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/perp/plp",
      function () {
        return require("private-next-pages/perp/plp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/perp/plp"])
      });
    }
  